import React from 'react'

const DeliveryAddComment = () => {
    return (
        <div>
            <div className="modal fade cusmodl" id="DeliveryAddComment" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header d-flex justify-content-between">
                            <h5 className="modal-title" id="exampleModalLabel">Add Comment</h5>
                            <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">✗</button>
                            </div>
                            <div className="modal-body">
                               <textarea className="form-control" placeholder="Add Comment"></textarea>
                               <button className="btn btn-primary w-100 mt-16">Submit</button>
                                </div>
                                </div>
                                </div>
                                </div>
        </div>
    )
}

export default DeliveryAddComment
